import { isDevelopment, isStaging } from './environmentByHostname';

/**
 * Logger Utility
 * Centralizes development logs and hides them in production.
 */
export const logger = {
    dev: (context: string, message: string, ...data: unknown[]): void => {
        if (isDevelopment() || isStaging()) {
            console.log(
                `%c[${context}]%c ${message}`,
                'color: #2ecc71; font-weight: bold;', // Green for context
                'color: inherit; font-weight: normal;',
                ...data
            );
        }
    },
};
